<template>
  <div id="app" class="container">
    <b-navbar id="cheader">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img :src="logo_src" alt="Lightweight UI components for Vue.js based on Bulma" />
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/' }" class="has-text-weight-medium">小黄书</b-navbar-item>
      </template>
      <template slot="start">
        <b-navbar-dropdown class="has-text-weight-medium" label="Info">
          <b-navbar-item href="#">关于我们</b-navbar-item>
        </b-navbar-dropdown>
      </template>

      <template slot="end">
        <b-navbar-item tag="div">
          <div class="buttons">
            <a class="button is-primary">
              <strong>注册</strong>
            </a>
            <a class="button is-light">登陆</a>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>

    <router-view id="content" />
  </div>
</template>


<script>
export default {
  name: "app",
  components: {
    // LandingPage
    // GoMobileCard
  },

  data: function() {
    return {
      lang: "en",
      admin_pw: "",
      logo_src: require("./assets/logo.png")
    };
  },
  metaInfo: {
    title: "TV Demo",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: "en"
    }
  },

  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
@import "./style/variable.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  // background-color: blueviolet;
  max-width: 960px;
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#cheader {
  background-color: $headfoot-bg;
  padding: 0.5em;
}
</style>
